import React from 'react';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { NavigationItem as NavigationItemType } from '@/types/navigation';
import PositPlusLogo from '@/components/shared/PositPlusLogo';

interface NavigationItemProps {
  item: NavigationItemType;
  onClick?: () => void;
}

const NavigationItem: React.FC<NavigationItemProps> = ({ item, onClick }) => {
  const IconComponent = item.icon;
  const isPremiumFeature = item.isPremium && !item.hasAccess;

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={onClick}
      className={cn(
        "w-full justify-start gap-2.5 px-2.5 py-2 h-auto text-sm font-normal",
        "text-muted-foreground hover:text-foreground hover:bg-muted/50",
        item.isActive && "bg-muted text-foreground",
        isPremiumFeature && "opacity-60 cursor-pointer"
      )}
    >
      {IconComponent && <IconComponent className="h-4 w-4 flex-shrink-0" />}
      <span className="flex-1 text-left truncate">{item.label}</span>
      
      {/* Premium indicator */}
      {item.isPremium && !item.hasAccess && (
        <PositPlusLogo size="sm" className="ml-auto" />
      )}
      
      {/* Regular badge */}
      {item.badge && !item.isPremium && (
        <Badge variant="secondary" className="text-xs px-1 py-0 h-4">
          {item.badge}
        </Badge>
      )}
    </Button>
  );
};

export default NavigationItem; 